export default __webpack_public_path__ + "static/media/live-dealer.b5262ced.png";